import definitions from "../../definitions";
import MinigameChickenRun from "./minigames/MinigameChickenRun";
import MinigameDucklingTrain from "./minigames/MinigameDucklingTrain";
import MinigameSnakeAttack from "./minigames/MinigameSnakeAttack";
import MinigameSimonSays from "./minigames/MinigameSimonSays";
import QuestDummy from "./QuestDummy";
import QuestFetch from "./QuestFetch";
import QuestFillCollectionJar from "./QuestFillCollectionJar";
import QuestKill from "./QuestKill";
import QuestBossFight from "./QuestBossFight";
import MinigameButterflyCatch from "./minigames/MinigameButterflyCatch";

export default class QuestFactory {
    /**
     * @param {string} type
     * @param {string} id
     * @param {string} owner
     * @returns {Quest}
     */
    static create(type, id, owner) {
        switch (type) {
            case definitions.QUEST_TYPE.BOSS_FIGHT: {
                return new QuestBossFight(id, owner);
            }
            case definitions.QUEST_TYPE.DUMMY: {
                return new QuestDummy(id, owner);
            }
            case definitions.QUEST_TYPE.FETCH: {
                return new QuestFetch(id, owner);
            }
            case definitions.QUEST_TYPE.FILL_COLLECTION_JAR: {
                return new QuestFillCollectionJar(id, owner);
            }
            case definitions.QUEST_TYPE.KILL: {
                return new QuestKill(id, owner);
            }
            case definitions.QUEST_TYPE.MINIGAME_SNAKE_ATTACK: {
                return new MinigameSnakeAttack(id, owner);
            }
            case definitions.QUEST_TYPE.MINIGAME_CHICKEN_RUN: {
                return new MinigameChickenRun(id, owner);
            }
            case definitions.QUEST_TYPE.MINIGAME_DUCKLING_TRAIN: {
                return new MinigameDucklingTrain(id, owner);
            }
            case definitions.QUEST_TYPE.MINIGAME_SIMON_SAYS: {
                return new MinigameSimonSays(id, owner);
            }
            case definitions.QUEST_TYPE.MINIGAME_BUTTERFLY_CATCH: {
                return new MinigameButterflyCatch(id, owner);
            }
        }
        return null;
    }

    /**
     * @param {string} type
     * @return {boolean}
     */
    static isMinigame(type) {
        switch (type) {
            case definitions.QUEST_TYPE.MINIGAME_BUTTERFLY_CATCH:
            case definitions.QUEST_TYPE.MINIGAME_CHICKEN_RUN:
            case definitions.QUEST_TYPE.MINIGAME_DUCKLING_TRAIN:
            case definitions.QUEST_TYPE.MINIGAME_SNAKE_ATTACK:
            case definitions.QUEST_TYPE.MINIGAME_SIMON_SAYS: {
                return true;
            }
        }
        return false;
    }

    /**
     * @param {string} type
     * @returns {boolean}
     */
    static isBossFight(type) {
        switch (type) {
            case definitions.QUEST_TYPE.BOSS_FIGHT: {
                return true;
            }
        }
        return false;
    }
}